<template>
    <el-upload :accept="accept" ref="upload" :on-error="onerror" :on-change="onchange" :on-success="success" :limit="1"
        :action="action" :headers="headers" name="multipartFiles" :on-preview="handlePreview" :on-remove="handleRemove"
        :file-list="fileList" :auto-upload="false" :show-file-list="false">
        <div class="el-input el-input--suffix">
            <div class="el-input__inner" v-if="!fileList.length">
                <el-button slot="trigger" size="mini" type="warning">选择录音文件</el-button>
                <span class="tip">支持格式: mp3, mp4, mpga, m4a, wav, webm 且不超过25M</span>
            </div>
            <div class="el-input__inner" v-else @click.stop="">
                <el-tag type="danger" size="small" effect="dark" closable @close="remove(index)"
                    v-for="(item, index) in fileList" :key="index">{{ item.name }}</el-tag>
            </div>
            <span class="el-input__suffix" @click.stop="submitUpload" v-if="fileList.length">
                <span class="el-input__suffix-inner">
                    <i class="el-icon-position el-input__icon"></i>
                </span>
            </span>
        </div>
    </el-upload>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: "uploadPic",
    computed: {
        ...mapGetters(["token"])
    },
    data() {
        return {
            // eslint-disable-next-line no-undef
            action: u_config.gptApi + "chatgpt/chatVoiceToText",
            headers: { Authorization: "" },
            fileList: [],
            // accept: "audio/*",
            accept: ".mp3,.mp4,.mpga,.m4a,.wav,.webm",
        };
    },
    methods: {
        onerror(error) {
            console.log(error);
            this.$store.commit("hideLoading");
            this.$message.error("解读失败了哦，重新试试")
        },
        onchange(file, fileList) {
            this.fileList = fileList;
        },
        submitUpload() {
            this.$store.commit("showLoading", "AI思考中。。。")
            this.$refs.upload.submit();
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
        remove(index) {
            this.fileList.splice(index, 1)
        },
        success(res) {
            this.$store.commit("hideLoading");
            this.$emit("success",
                [
                    {
                        "assistantType": 1,
                        "text": this.fileList[0].name
                    },
                    {
                        "assistantType": 2,
                        "text": res.result
                    },
                ]
            )
            this.$refs.upload.clearFiles();
        }
    },
    created() {
        this.headers.Authorization = this.token;
    },
}
</script>
<style lang="scss">
.el-upload {
    width: 100%;
}

.el-input--suffix .el-input__inner {
    text-align-last: left;
    display: flex;
    align-items: center;
    padding: 5px 15px;

    .el-button {
        padding: 6px 15px;
    }

    .tip {
        font-size: 12px;
        color: #999;
        padding-left: 15px;
    }

    .el-tag {
        margin-right: 10px;
    }
}
</style>